import request from "@/utils/request";
import { th } from "element-plus/es/locales.mjs";

const { ElMessage } = require("element-plus");

export default {
  name: "BuildingPanel",
  components: {},
  data() {
    const checkStuNum = (rule, value, callback) => {
      request.get("/stu/exist/" + value).then((res) => {
        if (res.code !== "0") {
          callback(new Error(res.msg || "学员不存在"));
          return;
        }
        // 检查学生床位情况，支持换房
        request.get("/room/judgeHadBed/" + value).then((result) => {
          if (result.code === "0") {
            // 学生无床位，直接通过
            callback();
          } else {
            // 学生已有床位，检查是否是换房（允许换房）
            // 换房逻辑：如果目标宿舍和床位与当前不同，允许换房
            const currentRoom = result.currentRoom || '';
            const targetRoom = this.checkInForm.targetDormBuildId + '-' + this.checkInForm.targetDormRoomId;
            const targetBed = this.checkInForm.targetDormBed;
            if (result.currentBed === targetBed && currentRoom === targetRoom) {
              callback(new Error("该学员已在此床位，无需重复入住"));
            } else {
              // 允许换房，通过验证
              callback();
            }
          }
        });
      });
    };
    return {
      bedNum: 0,
      havePeopleNum: 0,
      loading: true,
      disabled: false,
      judge: false,
      dialogVisible: false,
      checkIndialogVisible: false,
      bedDialog: false,
      stuInfoDialog: false,
      bedName: "",
      search: "",
      currentPage: 1,
      pageSize: 9999,
      total: 0,
      tableData: [],
      panelData: {},
      form: {
        dormRoomId: "",
        dormBuildId: "",
        floorNum: "",
        maxCapacity: "",
        currentCapacity: "",
        firstBed: "",
        secondBed: "",
        thirdBed: "",
        fourthBed: "",
        status: "1",
      },
      rules: {
        dormRoomId: [
          { required: true, message: "请输入房间号", trigger: "blur" },
          {
            pattern: /^[0-9]{4}$/,
            message: "范围：1000-9999",
            trigger: "blur",
          },
        ],
        floorNum: [
          { required: true, message: "请输入楼层数", trigger: "blur" },
          { pattern: /^[1-3]$/, message: "范围：1-3", trigger: "blur" },
        ],
        dormBuildId: [
          { required: true, message: "请输入楼宇号数", trigger: "blur" },
          { pattern: /^[1-4]$/, message: "范围：1-4", trigger: "blur" },
        ],
        maxCapacity: [
          { required: true, message: "请输入房间可住人数", trigger: "blur" },
          { pattern: /^[0-4]$/, message: "范围：0-4", trigger: "blur" },
        ],
        currentCapacity: [
          { required: true, message: "请输入当前已住人数", trigger: "blur" },
          { pattern: /^[0-4]$/, message: "范围：0-4", trigger: "blur" },
        ],
        firstBed: [{ validator: checkStuNum, trigger: "blur" }],
        secondBed: [{ validator: checkStuNum, trigger: "blur" }],
        thirdBed: [{ validator: checkStuNum, trigger: "blur" }],
        fourthBed: [{ validator: checkStuNum, trigger: "blur" }],
      },
      checkInRules: {
        username: [
          { required: true, message: "请输入学员姓名", trigger: "blur" },
          { validator: checkStuNum, trigger: "blur" },
        ],
        targetDormBed: [
          { required: true, message: "请选择床位", trigger: "blur" },
        ],
      },
      checkInForm: {
        username: "",
        currentDormInfo: "1-1101-3床位",
        targetDormBuildId: "",
        targetDormRoomId: "",
        targetDormBed: "",
      },
      stuOptions: [],
      bebOptions: [
        {
          label: "一号床位",
          value: "firstBed",
        },
        {
          label: "二号床位",
          value: "secondBed",
        },
        {
          label: "三号床位",
          value: "thirdBed",
        },
        {
          label: "四号床位",
          value: "fourthBed",
        },
      ],
      stuLoading: false,
      buildingOpts: [],
      dormBuildId: "",
      identity: "",
      dormBuildIds: [],  // 宿管管理的楼栋列表
      isFullscreen: false,
      classColorLegend: [],  // 班级颜色图例
    };
  },
  created() {
    this.identity = window.sessionStorage.getItem("identity");
    const user = JSON.parse(window.sessionStorage.getItem("user") || '{}');
    this.dormBuildIds = user.dormBuildIds || [];
    this.getBuildingOpts();
    this.loadClassColors();  // 加载班级颜色图例
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
  },
  watch: {
    dormBuildId() {
      this.load();
    }
  },
  beforeUnmount() {
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
  },
  methods: {
    remoteMethod(query) {
      if (query) {
        this.stuLoading = true;
        request
          .get("/stu/find", {
            params: {
              pageNum: 1,
              pageSize: 20,
              search: query,
            },
          })
          .then((res) => {
            this.stuLoading = false;
            this.stuOptions = res.data.records;
          });
      } else {
        this.stuOptions = [];
      }
    },
    async load() {
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        search: this.search,
      };
      if (this.dormBuildId) {
        params.dormBuildId = this.dormBuildId;
      }
      request
        .get("/room/find", {
          params: params,
        })
        .then((res) => {
          this.total = res.data.total;
          this.loading = false;
          this.tableData = res.data.records;
          // 增加房间状态字段，当前人数和最大人数currentCapacity、maxCapacity
          this.tableData.forEach((item) => {
            // 创建一个包含所有非空姓名的数组
            const bedNames = [];
            if (item.firstBedName) bedNames.push(item.firstBedName);
            if (item.secondBedName) bedNames.push(item.secondBedName);
            if (item.thirdBedName) bedNames.push(item.thirdBedName);
            if (item.fourthBedName) bedNames.push(item.fourthBedName);
            // 将数组中的姓名用逗号拼接成字符串
            item.bedNamesStr = bedNames.join(', ');

            // 状态：0空房, 1未满, 2满房, 3锁定
            // 使用 isLocked 字段判断锁定状态，兼容 status 字段
            const isLocked = item.isLocked === true || item.isLocked === 'true' || item.status === '0';
            
            if (isLocked) {
              item.state = 3; // 锁定
            } else if (item.roomType === 'problem') {
              item.state = 3; // 问题房间显示锁定
            } else if (item.currentCapacity === 0) {
              item.state = 0;
            } else if (item.currentCapacity < item.maxCapacity) {
              item.state = 1;
            } else {
              item.state = 2;
            }
            
            // 颜色：优先使用 roomColor > 班级颜色 > 房间类型 > 状态颜色
            if (item.roomColor && item.roomColor !== '#ffffff' && item.roomColor !== 'white') {
              item.displayColor = item.roomColor;
            } else if (item.roomType === 'problem' && item.problemNote) {
              item.displayColor = '#F56C6C'; // 问题房显示红色
            } else if (item.roomType && item.roomType !== 'normal') {
              // 特殊房间类型显示不同颜色
              const typeColorMap = {
                'problem': '#F56C6C',    // 问题房 - 红色
                'duty': '#E6A23C',       // 值班室 - 橙色
                'linen': '#409EFF',      // 布草间 - 蓝色
                'laundry': '#67C23A',    // 洗衣房 - 绿色
                'teacher': '#8e44ad',    // 教师收菜房 - 紫色
                'meeting': '#909399',    // 会议室 - 灰色
                'kitchen': '#E6A23C',    // 厨房 - 橙色
                'suite': '#FF69B4',      // 套房 - 粉色
                'engineer': '#795548',   // 工程房 - 棕色
                'pingpong': '#00BCD4',   // 乒乓球室 - 青色
                'accessible': '#8BC34A'  // 无障碍 - 浅绿色
              };
              item.displayColor = typeColorMap[item.roomType] || '#909399';
            } else if (item.primaryClassColor) {
              // 正常房间且有学员入住 → 使用班级颜色区分不同班级
              item.displayColor = item.primaryClassColor;
            } else if (item.state === 1) {
              item.displayColor = '#1ACAA8';
            } else if (item.state === 2) {
              item.displayColor = '#FF9461';
            } else if (item.state === 3) {
              item.displayColor = '#909399'; // 普通锁定显示灰色
            } else {
              item.displayColor = '#FFFFFF';
            }
            
            // 文字颜色
            if (item.displayColor === '#FFFFFF' || item.displayColor === '#ffffff' || item.displayColor === 'white') {
              item.textColor = '#333333';
            } else {
              item.textColor = '#FFFFFF';
            }
            
            // 房间类型标签
            const typeMap = {
              '': '正常/空房',
              'normal': '正常/空房',
              'problem': '问题房',
              'duty': '值班室',
              'laundry': '洗衣房',
              'linen': '布草间',
              'teacher': '教师收菜房',
              'kitchen': '厨房',
              'meeting': '会议室',
              'engineer': '工程房',
              'pingpong': '乒乓球室',
              'suite': '套房',
              'accessible': '无障碍'
            };
            item.typeLabel = typeMap[item.roomType] || item.roomType || '正常/空房';
            
            // 问题标记
            if (item.problemNote) {
              item.typeLabel = item.typeLabel + ' (' + item.problemNote + ')';
            }
          });

          console.log(this.organizeDormsByFloor(this.tableData));
          this.panelData = this.organizeDormsByFloor(this.tableData);
        });
    },
    organizeDormsByFloor(originalDormData, sortByRoomId = true) {
      // 先按楼宇分组，再按楼层分组
      const dormsByBuilding = new Map();

      originalDormData.forEach((room) => {
        const buildingId = room.dormBuildId ? room.dormBuildId.toString() : '0';
        if (!dormsByBuilding.has(buildingId)) {
          dormsByBuilding.set(buildingId, {
            buildingId: buildingId,
            buildingName: this.getBuildingName(buildingId),
            floors: new Map()
          });
        }
        const building = dormsByBuilding.get(buildingId);
        const floor = room.floorNum ? room.floorNum.toString() : '0';
        if (!building.floors.has(floor)) {
          building.floors.set(floor, []);
        }
        building.floors.get(floor).push(room);
      });

      // 按房间ID排序（可选）
      if (sortByRoomId) {
        dormsByBuilding.forEach((building) => {
          building.floors.forEach((rooms) => {
            rooms.sort((a, b) => a.dormRoomId - b.dormRoomId);
          });
        });
      }

      // 按楼层从高到低排序，并转换为数组
      const result = [];
      dormsByBuilding.forEach((building) => {
        const sortedFloors = [...building.floors].sort(([a], [b]) => b - a);
        building.floors = sortedFloors;
        result.push(building);
      });

      // 按楼宇ID排序
      result.sort((a, b) => a.buildingId - b.buildingId);

      return result;
    },
    getBuildingName(buildingId) {
      const building = this.buildingOpts.find(b => b.id && b.id.toString() === buildingId.toString());
      return building ? (building.dormBuildName || buildingId + '号楼') : buildingId + '号楼';
    },
    reset() {
      this.search = "";
      const params = {
        pageNum: 1,
        pageSize: this.pageSize,
        search: this.search,
      };
      if (this.dormBuildId) {
        params.dormBuildId = this.dormBuildId;
      }
      request
        .get("/room/find", {
          params: params,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
          // 增加房间状态字段，当前人数和最大人数currentCapacity、maxCapacity
          this.tableData.forEach((item) => {
            const isLocked = item.isLocked === true || item.isLocked === 'true' || item.status === '0';
            
            if (isLocked) {
              item.state = 3; // 锁定
            } else if (item.roomType === 'problem') {
              item.state = 3; // 问题房间显示锁定
            } else if (item.currentCapacity === 0) {
              item.state = 0;
            } else if (item.currentCapacity < item.maxCapacity) {
              item.state = 1;
            } else {
              item.state = 2;
            }
          });
          this.panelData = this.organizeDormsByFloor(this.tableData);
        });
    },
    filterTag(value, row) {
      return row.currentCapacity === value;
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.disabled = false;
        this.form = { status: "1" };
        this.judge = false;
      });
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.judge === false) {
            //新增
            request.post("/room/add", this.form).then((res) => {
              if (res.code === "0") {
                ElMessage({
                  message: "新增成功",
                  type: "success",
                });
                this.search = "";
                this.loading = true;
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          } else {
            //修改
            request.put("/room/update", this.form).then((res) => {
              if (res.code === "0") {
                ElMessage({
                  message: "修改成功",
                  type: "success",
                });
                this.search = "";
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          }
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
      this.bedDialog = false;
      this.stuInfoDialog = false;
    },
    handleCheckIn(row) {
      // 特殊房间类型不允许安排入住
      const noCheckInTypes = ['problem', 'duty', 'linen', 'laundry', 'teacher', 'meeting', 'kitchen', 'engineer', 'pingpong'];
      if (noCheckInTypes.includes(row.roomType)) {
        const typeMap = {
          'problem': '问题房',
          'duty': '值班室',
          'linen': '布草间',
          'laundry': '洗衣房',
          'teacher': '教师收菜房',
          'meeting': '会议室',
          'kitchen': '厨房',
          'engineer': '工程房',
          'pingpong': '乒乓球室',
          'accessible': '无障碍'
        };
        ElMessage({ type: 'warning', message: (typeMap[row.roomType] || row.roomType) + '不允许安排入住' });
        return;
      }
      this.checkInForm.targetDormBuildId = row.dormBuildId;
      this.checkInForm.targetDormRoomId = row.dormRoomId;
      this.checkIndialogVisible = true;
      this.checkInForm = {
        ...this.checkInForm,
        ...row,
      };
      this.bebOptions = [
        {
          label: "一号床位--" + (row.firstBed || "空"),
          value: "firstBed",
          stu: row.firstBed,
          disabled: false,
        },
        {
          label: "二号床位--" + (row.secondBed || "空"),
          value: "secondBed",
          stu: row.secondBed,
          disabled: false,
        },
        {
          label: "三号床位--" + (row.thirdBed || "空"),
          value: "thirdBed",
          stu: row.thirdBed,
          disabled: false,
        },
        {
          label: "四号床位--" + (row.fourthBed || "空"),
          value: "fourthBed",
          stu: row.fourthBed,
          disabled: false,
        },
      ];
      const maxCapacity = row.maxCapacity;
      //保留 最大床位数 disabled=true
      this.bebOptions = this.bebOptions.slice(0, maxCapacity);

      // 将不为空的床位 disabled=true
      this.bebOptions.forEach((option) => {
        if (option.stu) {
          option.disabled = true;
        }
      });
    },
    cancelCheckIn() {
      this.$refs.formCheckIn.resetFields();
      this.checkIndialogVisible = false;
    },
    handleEdit(row) {
      //修改
      this.judge = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(row));
        this.disabled = true;
      });
    },
    handleDelete(dormRoomId) {
      //删除
      request.delete("/room/delete/" + dormRoomId).then((res) => {
        if (res.code === "0") {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          this.search = "";
          this.load();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    calCurrentNum(info) {
      this.havePeopleNum = 0;
      // 获取房间人数
      let roomPeopleNum = 0;
      if (info.firstBed != null) {
        roomPeopleNum++;
      }
      if (info.secondBed != null) {
        roomPeopleNum++;
      }
      if (info.thirdBed != null) {
        roomPeopleNum++;
      }
      if (info.fourthBed != null) {
        roomPeopleNum++;
      }
      this.havePeopleNum = roomPeopleNum;
    },
    calRoomCurrentCapacity(info) {
      this.havePeopleNum = 0;
      // 获取房间人数
      let roomPeopleNum = 0;
      if (info.firstBed != null) {
        roomPeopleNum++;
      }
      if (info.secondBed != null) {
        roomPeopleNum++;
      }
      if (info.thirdBed != null) {
        roomPeopleNum++;
      }
      if (info.fourthBed != null) {
        roomPeopleNum++;
      }
      return roomPeopleNum;
    },
    plusIcon(num, info) {
      //添加图标
      this.judge = false;
      //显示对应床位input
      this.bedNum = num;
      //获取当前房间人数
      this.calCurrentNum(info);
      this.bedDialog = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(info));
      });
    },
    editIcon(num, info) {
      //修改图标
      this.judge = true;
      //显示对应床位input
      this.bedNum = num;
      //修改床位所住的学生
      this.bedDialog = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(info));
      });
    },
    detailIcon(num, info) {
      //查看床位所住的学生
      let stu = "";
      // 删除
      if (num === 1) {
        stu = info.firstBed;
      } else if (num === 2) {
        stu = info.secondBed;
      } else if (num === 3) {
        stu = info.thirdBed;
      } else if (num === 4) {
        stu = info.fourthBed;
      }
      request.get("/stu/exist/" + stu).then((res) => {
        if (res.code === "0") {
          this.stuInfoDialog = true;
          this.$nextTick(() => {
            this.$refs.form.resetFields();
            // 生拷贝
            this.form = JSON.parse(JSON.stringify(res.data));
          });
        }
      });
    },
    addStuBed() {
      this.$refs.formCheckIn.validate((valid) => {
        if (valid) {
          this.checkInForm[this.checkInForm.targetDormBed] =
            this.checkInForm.username;
          let realCurrentCapacity = this.calRoomCurrentCapacity(
            this.checkInForm
          );
          if (this.checkInForm.currentCapacity < realCurrentCapacity) {
            this.checkInForm.currentCapacity = realCurrentCapacity;
          }
          request.put("/room/update", this.checkInForm).then((res) => {
            if (res.code === "0") {
              ElMessage({
                message: "操作成功",
                type: "success",
              });
              this.search = "";
              this.loading = true;
              this.load();
              this.checkIndialogVisible = false;
            } else {
              ElMessage({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    editStuBed() {
      //修改
      this.$refs.form.validate((valid) => {
        if (valid) {
          request.put("/room/update", this.form).then((res) => {
            if (res.code === "0") {
              ElMessage({
                message: "修改成功",
                type: "success",
              });
              this.search = "";
              this.loading = true;
              this.load();
              this.bedDialog = false;
            } else {
              ElMessage({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    async deleteStuBed(bedNum, info) {
      let bedName = "";
      // 删除
      if (bedNum === 1) {
        bedName = "first_bed";
      } else if (bedNum === 2) {
        bedName = "second_bed";
      } else if (bedNum === 3) {
        bedName = "third_bed";
      } else if (bedNum === 4) {
        bedName = "fourth_bed";
      }
      //更新当前房间人数
      this.calCurrentNum(info);
      request
        .delete(
          "/room/delete/" +
            bedName +
            "/" +
            info.dormRoomId +
            "/" +
            this.havePeopleNum
        )
        .then((res) => {
          if (res.code === "0") {
            ElMessage({
              message: "删除成功",
              type: "success",
            });
            this.search = "";
            this.loading = true;
            this.load();
            this.bedDialog = false;
          } else {
            ElMessage({
              message: res.msg,
              type: "error",
            });
          }
        });
    },
    // 快速退房（从房间面板popover直接退房）
    quickCheckOut(bedNum, info) {
      this.deleteStuBed(bedNum, info);
    },
    handleSizeChange(pageSize) {
      //改变每页个数
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange(pageNum) {
      //改变页码
      this.currentPage = pageNum;
      this.load();
    },
    async getBuildingOpts() {
      request
        .get("/building/find", {
          params: {
            pageNum: 1,
            pageSize: 9999,
          },
        })
        .then((res) => {
          console.log(res);
          // 宿管只显示自己管理的楼栋
          if (this.identity === 'dormManager' && this.dormBuildIds.length > 0) {
            const myBuildings = res.data.records.filter(b => this.dormBuildIds.includes(b.dormbuild_id || b.id));
            this.buildingOpts = myBuildings;
            this.dormBuildId = myBuildings.length > 0 ? (myBuildings[0].dormbuild_id || myBuildings[0].id) : "";
          } else {
            this.buildingOpts = [
              { id: "", dormBuildName: "全部", dormBuildDetail: "所有楼宇" },
              ...res.data.records,
            ];
            this.dormBuildId = "";
          }
          this.load();
        });
    },
    loadClassColors() {
      // 加载所有班级的颜色标记，用于图例展示
      request.get("/classInfo/list").then(res => {
        if (res.code === '0' && res.data) {
          // 只保留有颜色且当前在住（离校日期>=今天或未设置离校日期）的班级
          const today = new Date().toISOString().slice(0, 10);
          this.classColorLegend = res.data
            .filter(c => c.colorTag && (!c.endDate || c.endDate >= today))
            .map(c => ({
              className: c.className,
              color: c.colorTag
            }));
        }
      }).catch(() => {});
    },
    toggleFullscreen() {
      // 获取 el-card 的实际 DOM 元素
      const elCard = this.$refs.panelContainer;
      const el = elCard && elCard.$el ? elCard.$el : document.documentElement;
      if (!document.fullscreenElement) {
        el.requestFullscreen().then(() => {
          this.isFullscreen = true;
        }).catch((err) => {
          ElMessage({
            message: "全屏模式失败: " + err.message,
            type: "error",
          });
        });
      } else {
        document.exitFullscreen().then(() => {
          this.isFullscreen = false;
        });
      }
    },
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
    },
  },
};
